import { InjectionToken } from '@angular/core';

export interface IStorageService {
  getItem(key: string): any;
  setItem(key: string, value: any): void;
  removeItem(key: string): void;
  clear(): void;
}

export enum StorageKey {
  AUTH = 'auth',
  AMPLIFY_FEDERATED_INFO = 'aws-amplify-federatedInfo',
}

export interface Storage {
  length: number;
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
  clear(): void;
  key(index: number): string | null;
}

export const STORAGE_TOKEN = new InjectionToken<Storage>('storage');
